// JapanPhD.js
import React from "react";
import Header from "../../components/Header";

import Footer from "../../components/Footer";
import DrpEduNavbar from "../../components/DrpEduNavbar";

const JapanPhD = () => {
  return (
    <>
      <Header />
      <DrpEduNavbar />

      <div className="phd-container">
        <h1 className="country-title">🎓 PhD & Postdoc in Japan</h1>

        {/* PhD Section */}
        <section className="phd-section">
          <h2>PhD – Key Highlights</h2>
          <ul>
            <li>
              <strong>Duration:</strong> 3 to 5 years
            </li>
            <li>
              <strong>Language:</strong> Many top universities offer
              English-taught PhD programs
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>Master’s degree (in a relevant field)</li>
                <li>English proficiency (TOEFL/IELTS) or Japanese (JLPT)</li>
                <li>Research proposal and strong academic record</li>
              </ul>
            </li>
            <li>
              <strong>Funding:</strong>
              <ul>
                <li>
                  MEXT (Monbukagakusho) Scholarship – Fully funded by the
                  Japanese government
                </li>
                <li>University assistantships and fellowships</li>
                <li>Stipend: ¥143,000–¥148,000/month (~$950–1,000 USD)</li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Postdoc Section */}
        <section className="postdoc-section">
          <h2>Postdoc – Key Highlights</h2>
          <ul>
            <li>
              <strong>Duration:</strong> 1 to 3 years (extendable)
            </li>
            <li>
              <strong>Eligibility:</strong> Completed PhD with a strong
              publication record
            </li>
            <li>
              <strong>Funding:</strong>
              <ul>
                <li>
                  JSPS Postdoctoral Fellowship (Japan Society for the Promotion
                  of Science)
                </li>
                <li>University or lab-based research projects</li>
                <li>Salary: ¥250,000–¥400,000/month (~$1,700–2,700 USD)</li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Top Universities Section */}
        <section className="universities-section">
          <h2>Top Universities in Japan</h2>
          <ol>
            <li>University of Tokyo</li>
            <li>Kyoto University</li>
            <li>Osaka University</li>
            <li>Tokyo Institute of Technology (Tokyo Tech)</li>
            <li>Tohoku University</li>
            <li>Nagoya University</li>
            <li>Kyushu University</li>
            <li>Hokkaido University</li>
            <li>Keio University</li>
            <li>Waseda University</li>
          </ol>
        </section>

        <a href="/" className="back-home-button">
          Go Back Home
        </a>
      </div>

      <Footer />
    </>
  );
};

export default JapanPhD;
